import React from 'react';

import { Message, Visible } from 'src/core/components';

import { ProductDescription, ProductStatus, SelectAll, SelectOne, ActionsCell } from './components';
import messages from './messages';

export default ({
  addProductId,
  removeProductId,
  setSelectedItems,
  productsIds,
  selectedProductsIds,
  isViewAllActive
}) => [
  {
    Header: (
      <Visible when={!isViewAllActive && productsIds.length}>
        <SelectAll
          {...{
            itemsIds: productsIds,
            selectedItemsIds: selectedProductsIds,
            setSelectedItems,
          }}
        />
      </Visible>
    ),
    accessor: 'checkbox',
    Cell: (props) => (
      <SelectOne
        {...{
          ...props,
          addItem: addProductId,
          removeItem: removeProductId,
          selectedItemsIds: selectedProductsIds,
        }}
      />
    ),
  },
  {
    Header: <Message message={messages.nameAndDescription} literal />,
    accessor: 'nameDescription',
    Cell: (props) => <ProductDescription {...props} />,
  },
  {
    Header: <Message message={messages.product} literal />,
    accessor: 'product',
  },
  {
    Header: <Message message={messages.status} literal />,
    accessor: 'status',
    Cell: (props) => <ProductStatus {...props} />,
  },
  {
    Header: <Message message={messages.lastModified} literal />,
    accessor: 'lastModified',
  },
  {
    Header: <Message message={messages.actions} literal />,
    accessor: 'actions',
    Cell: (props) => <ActionsCell {...props} />,
  }
];
